export default "__VITE_ASSET__NYS7EB31__"